import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../hooks/toolkit'
import Container from '../components/Container'

const Support = () => {
  const { t } = useTranslation()
  usePageTitle('Support | Agami')
  return (
    <Container direction="col">
      <Typography variant="h1">{t('support.title')}</Typography>

      <div className="w-full mt-8 text-left">
        <Typography variant="h2">{t('support.contactUs')}</Typography>

        <Typography variant="h4" className="mt-6 underline">
          <a href="mailto:agami@mezzoforte.design">{t('support.agamiEmail')}</a>
        </Typography>
        <Typography className="mt-1 mb-4">{t('support.agamiDescription')}</Typography>

        <Typography variant="h4" className="mt-6 underline">
          <a href="mailto:dpo@mezzoforte.design">{t('support.dpoEmail')}</a>
        </Typography>
        <Typography className="mt-1 mb-4">{t('support.dpoDescription')}</Typography>
      </div>
    </Container>
  )
}

export default Support
